export type DebugConfig = {
  auth?: boolean;
  storage?: boolean;
  state?: boolean;
  reducer?: boolean;
  dumpLogs?: boolean;
  user?: boolean;
};

export const isDebugModeEnabled = () => {
  try {
    return localStorage.getItem('DEBUG_MODE_ON') === 'true';
  } catch {
    return false;
  }
};

export function getDebugModeConfig(): DebugConfig {
  try {
    return JSON.parse(localStorage.getItem('DEBUG_MODE_CONFIG') || '') as DebugConfig;
  } catch {
    return {};
  }
}
